import type { AdminQuoteGuest } from '@repo/api-contracts';

const EMAIL_NOTICE = '발행하면 고객 이메일로 견적 링크가 갑니다.';
const PHONE_NOTICE = '발행 뒤 [링크 복사]로 카카오톡에 보내 주세요.';

/**
 * 발행 영역·확인창에 덧붙일 비회원 안내(비회원 견적 설계 G14·G15).
 * 연결 전 이메일 고객에게는 발행 때 서버가 링크 메일을 보내고, 휴대폰 고객에게는 운영자가 [링크 복사]로 직접 보낸다.
 * 회원 견적과 회원 계정에 연결된 비회원 견적에는 링크 메일이 가지 않으므로(G15) 안내가 없다(null).
 */
export const guestIssueNotice = (guest: AdminQuoteGuest | null): string | null => {
  if (guest === null || guest.claimed) return null;
  return guest.contactMethod === 'EMAIL' ? EMAIL_NOTICE : PHONE_NOTICE;
};
